import { render, staticRenderFns } from "./GenreLocalization.vue?vue&type=template&id=e6cc86fa&scoped=true&"
import script from "./GenreLocalization.vue?vue&type=script&lang=js&"
export * from "./GenreLocalization.vue?vue&type=script&lang=js&"
import style0 from "./GenreLocalization.vue?vue&type=style&index=0&id=e6cc86fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cc86fa",
  null
  
)

export default component.exports